import React, {FC} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../_metronic/helpers'
import {
  usePaymentHistory,
  usePaymentHistoryCustomer,
} from '../../contextProviders/Atomqueryprovider'
import dayjs from 'dayjs'

interface Props {
  show: boolean
  handleClose: () => void
  invoice_id?: string
  customer_id?: string
}

const addCommas = (num: any) => {
  if (num === undefined || num === null || num === '') return '0'
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  if (isNaN(numValue)) return '0'
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const PaymentHistory: FC<Props> = ({show, handleClose, invoice_id, customer_id}) => {
  const {data: invoiceHistory, isLoading: invoiceLoading} = usePaymentHistory(invoice_id || '')
  const {data: customerHistory, isLoading: customerLoading} = usePaymentHistoryCustomer(
    customer_id || ''
  )

  const historyData = invoice_id ? invoiceHistory : customerHistory
  const isLoading = invoice_id ? invoiceLoading : customerLoading
  const CURRENCY_APP = process.env.REACT_APP_CURRENCY || 'KSH'

  const title = invoice_id ? `Payment History: ${invoice_id}` : 'Customer Payment History'

  return (
    <Modal show={show} onHide={handleClose} size='lg'>
      <div className='modal-header'>
        <h2 className='fw-bolder'>{title}</h2>
        <div className='btn btn-icon btn-sm btn-active-icon-primary' onClick={handleClose}>
          <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
        </div>
      </div>

      <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
        {isLoading ? (
          <div className='d-flex justify-content-center'>
            <div className='spinner-border text-primary' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : historyData?.data && historyData.data.length > 0 ? (
          <div className='table-responsive'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <thead>
                <tr className='fw-bolder text-muted bg-light'>
                  <th className='ps-4 min-w-150px rounded-start'>Date</th>
                  <th className='min-w-100px'>Amount</th>
                  <th className='min-w-100px'>Payment Mode</th>
                  <th className='min-w-100px rounded-end'>User ID</th>
                </tr>
              </thead>
              <tbody>
                {historyData.data.map((payment: any, index: number) => (
                  <tr key={index}>
                    <td className='ps-4'>
                      <span className='text-dark fw-bolder d-block fs-6'>
                        {dayjs(payment.payment_date).format('LL')}
                      </span>
                      <span className='text-muted fw-bold d-block fs-7'>
                        {dayjs(payment.payment_date).format('LTS')}
                      </span>
                    </td>
                    <td>
                      <span className='text-success fw-bolder d-block fs-6'>
                        {addCommas(Number(payment.amount_paid).toFixed(2))} {CURRENCY_APP}
                      </span>
                    </td>
                    <td>
                      <span className='badge badge-light-primary fw-bolder'>
                        {payment.payment_type_name || 'N/A'}
                      </span>
                    </td>
                    <td>
                      <span className='text-muted fw-bold d-block fs-7'>{payment.user_id}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className='text-center py-10'>
            <h4 className='text-muted'>No payment history found.</h4>
          </div>
        )}
      </div>

      <div className='modal-footer'>
        <button type='button' className='btn btn-light' onClick={handleClose}>
          Close
        </button>
      </div>
    </Modal>
  )
}
